import { Amplify } from 'aws-amplify';

const USER_POOL_ID = process.env.REACT_APP_USER_POOL_ID || 'us-east-1_PLACEHOLDER';
const USER_POOL_CLIENT_ID = process.env.REACT_APP_USER_POOL_CLIENT_ID || 'PLACEHOLDER';

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: USER_POOL_ID,
      userPoolClientId: USER_POOL_CLIENT_ID,
    },
  },
});

export { USER_POOL_ID, USER_POOL_CLIENT_ID };
